import React, { useEffect, useState, forwardRef } from 'react';

import {
    Box,
    Typography,
    Tabs,
    Tab,
    Table,
    TableHead,
    TableCell,
    TableRow,
    TableBody,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button,
    TextField,
    Grid,
    InputAdornment,
    IconButton
} from '@mui/material';

import dayjs from 'dayjs';
import { useAppContextFeatures } from '../../../context/AppContext'
import { useSystemPrompt } from '../../../hooks/useSystemPrompt';

// import { useDocuments, documentTypes, targetTypes, actionTypes } from "../../../hooks/api/useDocuments"
import { useDocumentValidation } from '../../../hooks/api/useDocumentValidation';
import { CommonIcons, icons } from '../../common/CommonIcons'

import { useSystemUtils } from '../../../hooks/useSystemUtils';
import { useTranslations } from '../../../hooks/useTranslations';

export default function VerifyInSaved(
    {
        row,
        enableEdit = false,
        documentType,
        targetType,
        actionType
    }
) {
    const { t } = useTranslations({ ns: ["common", "@document", "prompt"] })

    const { promptMessage } = useSystemPrompt()
    const { setSystemLoading } = useAppContextFeatures()
    const { formatDateTimeDisplay } = useSystemUtils();
    // const { get, unVerifyIn } = useDocuments(documentTypes.itemReceive, targetTypes.itemReceive, '', actionTypes.itemReceive.unVerifyIn)

    const {
        listVerifyInSaved,
        // performVerifyIn
        performUnVerifyIn
    } = useDocumentValidation({ documentType, targetType, actionType })

    const [dataSaved, setDataSaved] = useState([])
    const [editMode, setEditMode] = useState({
        enable: false,
        index: 0,
        qty: 0
    })

    const {
        document_id: documentId
    } = row

    const fetchSaved = async () => {

        setSystemLoading(true);

        try {

            let response = await listVerifyInSaved({ id: documentId, itemId: row.item_id });

            console.log('response', response)

            setDataSaved(response)


        } catch (error) {
            promptMessage(false, `${error.message}`)
        }

        setSystemLoading(false)

    }

    const onSubmit = async ({ item }) => {

        setSystemLoading(true);

        try {

            // check the validation
            if (parseFloat(editMode.qty) > parseFloat(item?.qty_receive)) {
                promptMessage(true, `${t('maxAllowed')} ${item?.qty_receive}`)
                return false
            }

            // [
            //     {
            //         "doc_item_id": "8979",
            //         "unverify_in_qty": "1",
            //         "unverify_in": {
            //             "slot_id": "184",
            //             "code": "fishballcarton",
            //             "custom_batch_no": "",
            //             "expiry_date": "2023-11-26"
            //         }
            //     }
            // ]

            let _item = {
                doc_item_id: item?.doc_item_id,
                unverify_in_qty: editMode?.qty,
                unverify_in: {
                    slot_id: item?.slot_id,
                    code: "",
                    custom_batch_no: item?.custom_batch_no,
                    expiry_date: item?.expiry_date ? dayjs(item.expiry_date).format("YYYY-MM-DD") : ""
                }
            }

            // const data = {
            //     actions: {
            //         items: [_item]
            //     }
            // }

            const data = [_item] // for update one row only

            // console.log('data', data, item)

            const response = await performUnVerifyIn({ id: documentId, data });

            promptMessage(true, t(`changesSaved`), response)

            // fetchData();
            // if(handleOnSuccess) handleOnSuccess()

        } catch (error) {
            promptMessage(false, `${error.message}`)
        }

        setSystemLoading(false)

        return true

    }

    useEffect(() => {

        fetchSaved()

    }, [])

    const RenderQtyAction = ({ item, index }) => {

        if (enableEdit === false) return <></>

        // check the edit mode is enabled
        if (enableEdit) {
            if (editMode?.enable && editMode.index === index) {
                return (
                    <Box display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"center"}>
                        <TextField
                            margin="dense"
                            size="small"
                            fullWidth
                            // name={"customBatchNo"}
                            label={t("deductQty")}
                            type="text"
                            variant="outlined"
                            value={editMode.qty}
                            onChange={(event) => {
                                setEditMode(
                                    { ...editMode, qty: event.target.value }
                                )
                            }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <CommonIcons name={icons.minus} />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <Box display={"flex"} flexDirection={"row"} justifyContent={"space-between"} alignItems={"center"}>
                            <Button
                                variant={"contained"}
                                color="primary"
                                size='small'
                                sx={{
                                    mr: 1
                                }}
                                onClick={async () => {
                                    await onSubmit({ item })
                                    fetchSaved()
                                    setEditMode(
                                        { ...editMode, enable: false, index: 0, qty: 0 }
                                    )
                                }}
                            >
                                <CommonIcons name={icons.save} />
                            </Button>
                            <Button
                                variant={"outlined"}
                                color="primary"
                                size='small'
                                onClick={() => {
                                    setEditMode(
                                        { ...editMode, enable: false, index: 0, qty: 0 }
                                    )
                                }}
                            >
                                <CommonIcons name={icons.cancel} />
                            </Button>
                        </Box>
                    </Box>
                )
            }
        }

        return (
            <>
                {/* {JSON.stringify(editMode)} */}
                <Button
                    variant='outlined'
                    color="primary"
                    size="small"
                    onClick={() => {
                        setEditMode(
                            { ...editMode, enable: true, index, qty: item?.qty_receive }
                        )
                    }}
                >
                    <Box display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"center"}>
                        <CommonIcons color={"primary"} name={icons.edit} sx={{ width: 20, height: 20 }} />
                    </Box>
                </Button>
            </>
        )
    }

    const RenderSaved = () => {

        if (dataSaved.length <= 0) return <></>

        return (
            <Table size="small">
                {/* <TableHead>
                    <TableRow>
                        <TableCell colSpan={4} align="center">Verify In Information</TableCell>
                    </TableRow>
                </TableHead> */}
                <TableHead>
                    <TableRow>
                        <TableCell width={50}>{t('no')}</TableCell>
                        <TableCell width={200}>{t('verifiedAt')}</TableCell>
                        <TableCell width={150}>{t('verifiedBy')}</TableCell>
                        {/* <TableCell>Location</TableCell> */}
                        <TableCell width={100}>{t('storage')}</TableCell>
                        <TableCell width={150}>{t('savedQty')}</TableCell>
                        {
                            enableEdit &&
                            <TableCell width={150}>{t('action')}</TableCell>
                        }
                        <TableCell width={150}>{t('batchNumber')}</TableCell>
                        <TableCell width={150}>{t('expiryDate')}</TableCell>
                        {/* {
                            !viewOnly &&
                            <TableCell width={300}><></></TableCell>
                        } */}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        dataSaved && dataSaved.map((i, index) => (
                            <TableRow key={index}>
                                <TableCell>{(index + 1)}</TableCell>
                                <TableCell component="th" scope="row">
                                    {formatDateTimeDisplay(i.ax_createdatetime)}
                                </TableCell>
                                <TableCell>{i.ax_createusername}</TableCell>
                                <TableCell>{i.rack_name}/{i.slot_name}</TableCell>
                                <TableCell>{i.qty_receive}</TableCell>
                                {
                                    enableEdit &&
                                    <TableCell>

                                        {
                                            RenderQtyAction({ item: i, index })
                                        }

                                    </TableCell>
                                }
                                <TableCell>{i?.custom_batch_no}</TableCell>
                                <TableCell>{i?.expiry_date}</TableCell>
                            </TableRow>
                        ))
                    }

                </TableBody>
            </Table>
        )
    }

    return (
        <Box
            sx={{
                height: '100%'
            }}
        >
            {/* {JSON.stringify(values)} */}
            {
                RenderSaved()
            }

        </Box>
    )
}